import React from 'react';
import { NavLink } from 'react-router-dom';
import { FiHome, FiFolder, FiBriefcase, FiMail, FiUsers, FiSettings, FiChevronLeft, FiFileText } from 'react-icons/fi';

const Sidebar = ({ isOpen, toggle }) => {
  const menuItems = [
    { path: '/', icon: <FiHome />, label: 'Dashboard' },
    { path: '/projects', icon: <FiFolder />, label: 'Projects' },
    { path: '/services', icon: <FiBriefcase />, label: 'Services' },
    { path: '/careers/jobs', icon: <FiUsers />, label: 'Careers' },
    { path: '/careers/applications', icon: <FiFileText />, label: 'Applications' },
    { path: '/messages', icon: <FiMail />, label: 'Service Messages' },
    { path: '/contact-messages', icon: <FiMail />, label: 'Contact Messages' },
    { path: '/settings', icon: <FiSettings />, label: 'Settings' },
  ];

  return (
    <>
      <style>{`
       .sidebar { position: fixed; left: 0; top: 0; height: 100vh; width: ${isOpen? '260px' : '80px'}; background: linear-gradient(180deg, #1E293B 0%, #0F172A 100%); transition: width 0.3s ease; z-index: 1000; }
       .sidebar-header { padding: 25px 20px; display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid rgba(255,255,255,0.1); }
       .logo { display: flex; align-items: center; gap: 12px; color: #FFF; font-size: 22px; font-weight: 800; }
       .logo-icon { width: 40px; height: 40px; background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%); border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 20px; }
       .toggle-btn { background: rgba(255,255,255,0.1); border: none; color: #FFF; width: 32px; height: 32px; border-radius: 8px; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: all 0.3s ease; }
       .toggle-btn:hover { background: rgba(59, 130, 246, 0.3); }
       .sidebar-nav { padding: 20px 12px; }
       .nav-item { display: flex; align-items: center; gap: 12px; padding: 14px 16px; margin-bottom: 6px; border-radius: 10px; color: #CBD5E1; text-decoration: none; transition: all 0.3s ease; }
       .nav-item:hover { background: rgba(59, 130, 246, 0.15); color: #3B82F6; transform: translateX(5px); }
       .nav-item.active { background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%); color: #FFF; box-shadow: 0 8px 20px rgba(59, 130, 246, 0.4); }
       .nav-icon { font-size: 20px; min-width: 20px; }
       .nav-label { font-size: 15px; font-weight: 600; white-space: nowrap; opacity: ${isOpen? '1' : '0'}; transition: opacity 0.3s ease; }
       .nav-badge { margin-left: auto; background: #EF4444; color: #FFF; padding: 2px 8px; border-radius: 12px; font-size: 11px; font-weight: 700; }
        @media (max-width: 768px) {.sidebar { transform: translateX(${isOpen? '0' : '-100%'}); width: 260px; } }
      `}</style>
      <aside className="sidebar">
        <div className="sidebar-header">
          {isOpen && <div className="logo"><div className="logo-icon">S</div><span>STOSIMO</span></div>}
          <button className="toggle-btn" onClick={toggle}>
            <FiChevronLeft style={{ transform: isOpen? 'rotate(0deg)' : 'rotate(180deg)' }} />
          </button>
        </div>
        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <NavLink key={item.path} to={item.path} className="nav-item">
              <span className="nav-icon">{item.icon}</span>
              {isOpen && <span className="nav-label">{item.label}</span>}
              {isOpen && item.badge && <span className="nav-badge">{item.badge}</span>}
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
};
export default Sidebar;